// Generate a random from 1 to n
// Take from: https://stackoverflow.com/questions/4959975/generate-random-number-between-two-numbers-in-javascript
export const fastRandom = (n: number): number =>
  Math.floor(Math.random() * n) + 1;
